import React from 'react';

import {
    ApiReferenceIcon,
    BlogIcon,
    ChangelogIcon,
    DocumentationIcon,
    GlossaryIcon,
    OssAndToolsIcon,
    SecurityServicesIcon,
    SupportIcon
} from 'pages/Landings/components/Icons';
import Title from 'pages/Landings/components/Title';

import Card from './components/Card';
import useStyles from './styles';

interface Props {
    className?: string;
}

const ResourcesSection: React.FC<Props> = ({ className }) => {
    const { cx, classes } = useStyles();
    return (
        <section className={cx(classes.root, className)}>
            <Title variant="h2">{'Resources'}</Title>
            <div className={classes.cards}>
                <Card
                    className={classes.card}
                    icon={<DocumentationIcon />}
                    title="Documentation"
                    href="https://docs.vulners.com"
                />
                <Card
                    className={classes.card}
                    icon={<ApiReferenceIcon />}
                    title="API Reference"
                    href="https://docs.vulners.com/docs/api/"
                />
                <Card
                    className={classes.card}
                    icon={<OssAndToolsIcon />}
                    title="OSS & Tools"
                    href="https://github.com/vulnerscom"
                />
                <Card
                    className={classes.card}
                    icon={<SecurityServicesIcon />}
                    title="Security Services"
                    href="https://pentest.vulners.com/"
                />
                <Card
                    className={classes.card}
                    icon={<ChangelogIcon />}
                    title="Changelog"
                    to="https://docs.vulners.com/changelog"
                />
                <Card className={classes.card} icon={<GlossaryIcon />} title="Glossary" to="/glossary" />
                <Card className={classes.card} icon={<BlogIcon />} title="Blog" to="/blog" />
                <Card className={classes.card} icon={<SupportIcon />} title="Support" to="/company/contacts" />
            </div>
        </section>
    );
};

export default ResourcesSection;
